<template>
    <div class="m-content">
        <div class="alert alert-light alert-elevate" role="alert">
<!--            <div class="alert-icon"><i class="flaticon-warning kt-font-brand"></i></div>-->
            <div class="alert-text">
                <div class="row">
                    <div class="col-2"></div>
                    <div class="col-2">
                        <router-link to="/dashboard/amoire-technique/themes" tag="button" class="btn btn-outline-success btn-elevate btn-pill" :class="activeTable === 'themes' ? 'active' : ''">
                            {{ labels.manage_themes|capitalize }}
                        </router-link>
                    </div>
                    <div class="col-3">
                        <router-link to="/dashboard/amoire-technique/segmentations" tag="button" class="btn btn-outline-success btn-elevate btn-pill" :class="activeTable === 'segmentations' ? 'active' : ''">
                            {{ labels.manage_parent_segmenatations|capitalize }}
                        </router-link>
                    </div>
                    <div class="col-3">
                        <router-link to="/dashboard/amoire-technique/child-segmentations" tag="button" class="btn btn-outline-success btn-elevate btn-pill" :class="activeTable === 'childSegmentations' ? 'active' : ''">
                            {{ labels.manage_child_segmenatations|capitalize }}
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <router-view name="amoireTechnique"></router-view>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
    name: 'SegmentationManager',
    data () {
        return {
            activeTable: ''
        }
    },
    watch: {
        '$route' (value) {
            // Watch when param changes
            this.activeTable = value.name || value.params.name
            this.toggleCRUDMode(null)
        }
    },
    computed: {
        ...mapState({
            labels: store => store.labels
        })
    },
    methods: {
        ...mapActions([
            'toggleCRUDMode'
        ])
    },
    mounted () {
        this.activeTable = this.$route.name || this.$route.params.name
    }
}
</script>

<style scoped>
    .btn-pill {
        border-radius: 30px;
    }

    .btn-outline-brand.active {
        color: #ffff !important;
    }

    .btn.btn-outline-brand:hover {
        color: #ffff !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/CRUDs/Segmentations/SegmentationManager.vue